import React, { useEffect } from 'react';
import { AppLogo } from '@/components/shared/display/Logo';
import { FormattedText } from '@/components/uiKit/FormattedText';
import { analytics } from '@/analytics';
import { CodeVerificationForm } from '@/pages/auth/components/CodeVerificationForm';
import { useLazyGetStatusQuery } from '@/store/api/authApi';
import { useSearchParams } from 'react-router-dom';

export const CodeVerificationPage = () => {
  const [searchParams] = useSearchParams();
  const [fetchAuthStatus, { data: authStatus }] = useLazyGetStatusQuery();

  useEffect(() => {
    analytics.page({
      name: 'Code Verification',
      title: 'DataMind Dashboard 2.0 - Code Verification',
    });
    fetchAuthStatus({});
  }, []);

  return (
    <div className="flex flex-col h-full justify-center px-4 xl:px-0">
      <div className="max-w-[26.25rem] mx-auto w-full bg-white xl:bg-transparent rounded-lg xl:rounded-none px-6 xl:px-0 py-12 xl:py-0">
        {/* Mobile Logo */}
        <div className="flex xl:hidden w-full justify-center mb-8">
          <AppLogo size="184px" />
        </div>

        <div className="flex items-center gap-3">
          <h1 className="text-2xl font-semibold text-center xl:text-left w-full xl:w-auto">
            <span className="block xl:hidden">
              <FormattedText label="auth.login.headingMobile" />
            </span>
            <span className="hidden xl:block">
              <FormattedText label="auth.login.heading" />
            </span>
          </h1>

          {/* Desktop Logo */}
          <div className="hidden xl:block ml-[-4px] mt-[-2px]">
            <AppLogo size="164px" />
          </div>
        </div>

        <div className="pb-10 pt-2 xl:pt-6 text-center xl:text-left">
          {authStatus ? (
            <div className="flex flex-col w-full items-start space-y-6">
              <div>
                <FormattedText
                  label="auth.2fa.description"
                  values={{
                    method: searchParams.get('method') === 'email' ? 'email' : 'phone',
                    methodValue:
                      searchParams.get('method') === 'email' ? authStatus.methods.email : authStatus.methods.sms,
                  }}
                />
              </div>
              <div>
                <FormattedText label="auth.2fa.codeIssueMessage" />
              </div>
            </div>
          ) : null}
        </div>

        <CodeVerificationForm />
      </div>
    </div>
  );
};